/* eslint-disable react/no-array-index-key, no-confusing-arrow */
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import "./css/carousel.css";

const settings = {
  infinite: false,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 2,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0
      }
    }
  ]
};

const Carousel = ({
  addButtonResponse,
  fixMissingImage,
  reply,
  scrollChatToBottom,
  showOverlay
}) => (
  <div data-quid="template-carousel" className="template--carousel">
    <Slider {...settings}>
      {reply.media.map((slide, index) => (
        <div key={index} className="template--carousel__slide">
          <h1 data-quid={`slide-title-${reply.template}-${index}`}>
            {slide.title}{" "}
          </h1>
          <h3>{slide.description} </h3>
          <img
            src={slide.image}
            alt={slide.title}
            onLoad={scrollChatToBottom}
            onError={evt => fixMissingImage(evt)}
          />
          {slide.buttons.map((button, buttonIndex) => (
            <button
              data-quid={`slide-button-${
                reply.template
              }-${index}${buttonIndex}`}
              key={buttonIndex}
              type="button"
              className="template--carousel__reply"
              onClick={() =>
                button.type === "account_link"
                  ? showOverlay("login", true)
                  : addButtonResponse(button.title, button.payload, slide.title)
              }
            >
              {button.title}
            </button>
          ))}
        </div>
      ))}
    </Slider>
  </div>
);

Carousel.propTypes = {
  reply: PropTypes.shape({
    media: PropTypes.arrayOf(PropTypes.object)
  }).isRequired,
  addButtonResponse: PropTypes.func.isRequired,
  scrollChatToBottom: PropTypes.func.isRequired,
  showOverlay: PropTypes.func,
  fixMissingImage: PropTypes.func.isRequired
};

Carousel.defaultProps = {
  showOverlay: null
};

export default Carousel;
